import React from 'react'
import CustomAnchor from '../custom-anchor'
import PopoverInfo from '../popover-info'

const NoteInfo = ({
    note = "",
    withInfoIcon = false,
    iconSrc,
    theme="light",
    anchorText,
    handleAnchorClick,
    anchorHref,
    anchorTarget = "_self",
    popoverNoteInfo,
    popoverNoteInfoPlacement = "right",
    popoverNoteClassName
}) => {
    return (
        <div className={`bimmatch-note-info note-info-${theme}`}>
            {withInfoIcon && <img src={iconSrc || `/images/icon/${theme === "light" ? "info-light": "info"}.svg`} className='info-icon' alt='info' />}
            <p className='note-info-message'>{note}</p>
            {anchorText && <CustomAnchor href={anchorHref} onClick={handleAnchorClick} target={anchorTarget}>{anchorText}</CustomAnchor>}
            {popoverNoteInfo && <PopoverInfo message={popoverNoteInfo} placement={popoverNoteInfoPlacement} className={popoverNoteClassName} />}
        </div>
    )
}

export default NoteInfo